import { AnimatePresence, motion } from "framer-motion";
import { WorkbenchTabBar } from "./WorkbenchTabBar";
import { useWorkbench } from "./workbench-provider";

export function WorkbenchTabBarSlot() {
  const { showTabs } = useWorkbench();

  return (
    <AnimatePresence initial={false}>
      {showTabs && (
        <motion.div
          key="workbench-tabbar"
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeInOut" }}
          className="shrink-0 overflow-hidden"
        >
          <WorkbenchTabBar />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
